import { render, staticRenderFns } from "./RaddarSync.vue?vue&type=template&id=23b6d45b&scoped=true&"
import script from "./RaddarSync.vue?vue&type=script&lang=js&"
export * from "./RaddarSync.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b6d45b",
  null
  
)

export default component.exports